import { FunctionComponent } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { RedirectionModalBody } from '../../../modal/RedirectionModalBody/RedirectionModalBody';
import {
  ConfirmModalProps,
  ConfirmationBodyExtraParams
} from '../../../modal/ConfirmModal/ConfirmModal';

export const getPostConfirmationDeleteDialogProps = (
  entity: string,
  params: string = ''
): Partial<ConfirmModalProps<object, object>> => {
  return {
    iconName: 'testing',
    iconProps: {
      isIconColorWhite: false,
      containerSize: 9,
      className: 'w-50, h-50 text-default'
    },
    title: `Deleting ${entity}...`,
    titleContainerClassName: 'text-error text-center center-flex-col mt-7',
    positiveButtonText: `Go to ${entity} list`,
    negativeButtonClass: 'd-none',
    bodyComponentProps: {
      title: `You will be navigated to the ${entity} listing page in`,
      timeToRedirect: 3
    },
    BodyComponent: RedirectionModalBody as FunctionComponent<
      Partial<ConfirmationBodyExtraParams<object>>
    >,
    positiveButtonClass: 'btn-secondary',
    positiveButtonVariation: 'outline',
    positiveButtonPalette: 'secondary',
    onPositiveClickCallback: extraParams => {
      return Promise.resolve(extraParams);
    },
    onClose: extraParams => {
      (extraParams as { navigate: NavigateFunction }).navigate(
        `/${entity.toLowerCase()}${params ? `/?${params}` : ''}`,
        {
          replace: true
        }
      );
    },
    positiveBtnProps: {
      icon: 'add-arrow-right',
      direction: 'right'
    },
    actionContainerClass: 'justify-center'
  };
};
